import { render, staticRenderFns } from "./DetailMain.vue?vue&type=template&id=4f21561c&scoped=true&"
import script from "./DetailMain.vue?vue&type=script&lang=js&"
export * from "./DetailMain.vue?vue&type=script&lang=js&"
import style0 from "./DetailMain.vue?vue&type=style&index=0&id=4f21561c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f21561c",
  null
  
)

export default component.exports